import { render, staticRenderFns } from "./countrywise.vue?vue&type=template&id=0327abdc&scoped=true"
import script from "./countrywise.vue?vue&type=script&lang=js"
export * from "./countrywise.vue?vue&type=script&lang=js"
import style0 from "./countrywise.vue?vue&type=style&index=0&id=0327abdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0327abdc",
  null
  
)

export default component.exports